import {Subscription } from 'rxjs';
import {Component, Input, OnInit} from '@angular/core';
import {Attachment} from '../../../common/model/attachment.model';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Base} from '../../../common/model/base.model';
import {ApiMessageService} from '../../../core/api-message.service';
import {AttachmentModalComponent} from '../attachments/attachment-modal.component';
import {CommonService} from '../../../common/controller/common.service';
import {Permission} from '../../../common/model/permission.enum';

@Component({
    selector: 'app-attachment-list',
    template: `
    <app-show-layout [strong]='true' [label]="'attachments'">
      <div *ngIf="attachments" [ngStyle]="{'position': 'relative', 'top': '-4px'}">
        <span>
          <em> {{ attachmentText() }}</em>
        </span>
        <button *ngIf="attachments.length > 0 || uploadEnabled" class="btn btn-sm btn-light d-inline-block ml-3"
                data-toggle="tooltip" data-placement="top" title="Gestisci allegati"
                (click)="openAttachmentModal()"
                >
          <i class="fa fa-folder-open-o" aria-hidden="true"></i>
        </button>
      </div>
    </app-show-layout>
    `,
    styles: [],
    standalone: false
})
export class AttachmentListComponent implements OnInit {

  @Input() entity: Base;

  @Input() serviceAttachment: CommonService<any>;

  @Input() uploadEnabled: boolean = true;

  @Input() deleteEnabled: boolean = true;

  attachments: Attachment[];

  subscriptions: Subscription[] = [];

  modalRef: BsModalRef;

  constructor(private modalService: BsModalService,
              protected apiMessageService: ApiMessageService,
              protected bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.serviceAttachment.getFiles(this.entity).subscribe(files => {
      this.attachments = files;
    });
    this.uploadEnabled = this.uploadEnabled && this.entity.hasPermission(Permission.UPDATE);
  }

  public attachmentText() {
    if (this.attachments.length === 0) {
      return 'Non sono presenti file allegati.';
    }
    if (this.attachments.length === 1) {
      return 'Presente 1 file allegato.';
    }
    return 'Presenti ' + this.attachments.length + ' files allegati.';
  }

  openAttachmentModal() {
    const config = {
      class: 'modal-dialog-centered modal-xl',
      backdrop: false
    };
    const initialState = {
      entity: this.entity,
      attachments: this.attachments,
      serviceAttachment: this.serviceAttachment,
      uploadEnabled: this.uploadEnabled,
      deleteEnabled: this.deleteEnabled
    };
    this.subscriptions.push(
      this.modalService.onHide.subscribe((reason: string) => {
        this.serviceAttachment.getFiles(this.entity).subscribe(files => {
          this.attachments = files;
        });
      })
    );
    this.modalRef = this.modalService.show(AttachmentModalComponent, Object.assign({initialState}, config));
  }
}

